export default function initVideoPlayer() {
  const videoContainer = document.querySelectorAll(".video-source-file");

  for (let i = 0; i < videoContainer.length; i++) {
    const video = videoContainer[i].querySelector("video");

    if (video) {
      video.addEventListener("playing", function (e) {
        videoContainer[i].classList.add("video-playing");
        videoContainer[i].classList.remove("video-plaused");
      });

      video.addEventListener("pause", function (e) {
        videoContainer[i].classList.remove("video-playing");
        videoContainer[i].classList.add("video-plaused");
      });
    }
  }
}
